import Dialog from 'components/common/Dialog'
import $t from 'i18n'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import { BROKER_PORTAL_LINK } from 'consts'

import './BrokerTimoutDialog.css'

export const BrokerTimoutDialog = () => {
  const shouldShowBrokerTimeoutModal = useSelector(
    state => state.app?.shouldShowBrokerTimeoutModal
  )

  return (
    <Dialog
      isVisible={shouldShowBrokerTimeoutModal}
      title={$t('dialogs.brokerTimeout.title')}
      className='broker-timeout-dialog'
      closable={false}
      footerActions={[
        <Button
          key='exit'
          onClick={() => window.open(BROKER_PORTAL_LINK, '_self')}
          type='primary'
        >
          {$t('dialogs.brokerTimeout.exit')}{' '}
        </Button>
      ]}
    >
      <div className='broker-timeout-dialog-content'>
        <div className='broker-timeout-dialog-subtitle subtitle'>
          {$t('dialogs.brokerTimeout.description')}
        </div>
      </div>
    </Dialog>
  )
}
export default BrokerTimoutDialog
